import React from 'react';
import {connect} from 'react-redux';
import BukkuTooltip from "bukku/components/Tooltip";
import Styled from './style';

function DescriptionCell(props) {
    const {
        text,
    } = props;

    return (
        <Styled>
            <BukkuTooltip
                title={text}
                placement="topLeft"
                // autoAdjustOverflow={false}
            >
                <div className="description">
                    { text || '-' }
                </div>
            </BukkuTooltip>
        </Styled>
    );
}
export default connect(() => ({
    //
}), {
    //
})(DescriptionCell);
